import React, {Component} from 'react';

import './login.css';

import {AuthenticationDetails, CognitoUser, CognitoUserAttribute, CognitoUserPool} from 'amazon-cognito-identity-js';

import {Cookies, withCookies} from 'react-cookie';
import {instanceOf} from "prop-types";
import {addLoginRecord} from "./operations/fetch";
import {getConfig} from "./Config"
import TopMenu from "./TopMenu";

class Login extends Component {

    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    constructor(props) {
        super(props);

        const { cookies } = props;

        let token_exist = cookies.get('arboreal_token') || false;

        this.state = {

            accessToken: cookies.get('arboreal_token') || false,
            cognitoUser: cookies.get('arboreal_user') || false,
            isLogin: token_exist !== false,

            register: false,
            verify: false,

            given: "",
            family: "",
            email: "",
            create_password: "",
            repeat_password: "",

            username: "",
            password: "",

            verification_code: ""
        };
    }

    login() {
        // Amazon Cognito creates a session which includes the id, access, and refresh tokens of an authenticated user.

        let authenticationData = {
            Username: this.state.username.toLowerCase(),
            Password: this.state.password,
        };

        let authenticationDetails = new AuthenticationDetails(authenticationData);

        let poolData = {
            UserPoolId: getConfig().userPoolId,
            ClientId: getConfig().clientId
        };
        let userPool = new CognitoUserPool(poolData);

        let userData = {
            Username: this.state.username,
            Pool: userPool
        };

        let cognitoUser = new CognitoUser(userData);

        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: (result) => {
                let accessToken = result.getAccessToken().getJwtToken();

                const { cookies } = this.props;
                cookies.set("arboreal_token", accessToken,  { path: '/', maxAge: 3600 });
                cookies.set("arboreal_user", cognitoUser.getUsername(),  { path: '/', maxAge: 3600 });

                let idToken = result.idToken.jwtToken;
                addLoginRecord(accessToken);
                this.setState({isLogin: true, idToken: idToken, cognitoUser: cognitoUser.getUsername(), accessToken: accessToken})
            },

            onFailure: function (err) {
                alert("User does not exist, or password was incorrect.");
            },
        });
    }

    register() {

        let poolData = {
            UserPoolId: getConfig().userPoolId,
            ClientId: getConfig().clientId
        };

        let userPool = new CognitoUserPool(poolData);

        let attributeList = [];

        let dataPhoneNumber = {
            Name: 'phone_number',
            Value: '+15555555555'
        };

        let attributePhoneNumber = new CognitoUserAttribute(dataPhoneNumber);

        attributeList.push(new CognitoUserAttribute({
            Name: 'email',
            Value: this.state.email.toLowerCase()
        }));

        attributeList.push(new CognitoUserAttribute({
            Name: 'given_name',
            Value: this.state.given
        }));

        attributeList.push(new CognitoUserAttribute({
            Name: 'family_name',
            Value: this.state.family
        }));

        attributeList.push(attributePhoneNumber);

        if(this.state.create_password !== this.state.repeat_password){
            alert("Passwords doesn't match");
            return;
        }

        userPool.signUp(this.state.email, this.state.create_password, attributeList, null, (err, result) => {
            if (err) {
                alert(err);
                return;
            }

            let cognitoUser = result.user;
            console.log('user name is ' + cognitoUser.getUsername());

            this.setState({verify: true})

            /*var verificationCode = prompt('An email has been sent to your email with an verification code,\n' +
                'Please input verification code: ', '');
            cognitoUser.confirmRegistration(verificationCode, true,
                function (err, result) {
                    alert(result)
            });*/

           /* cognitoUser.getAttributeVerificationCode('email', {
                onSuccess: function (result) {
                    console.log('call result: ' + result);
                },
                onFailure: function (err) {
                    alert(err);
                },
                inputVerificationCode: function () {
                  //  var verificationCode = prompt('Please input verification code: ', '');
                    cognitoUser.verifyAttribute('email', verificationCode, this);
                }
            });*/

        });
    }

    verifyEmail(){
        let poolData = {
            UserPoolId: getConfig().userPoolId,
            ClientId: getConfig().clientId
        };
        let userPool = new CognitoUserPool(poolData);

        let userData = {
            Username: this.state.email.toLowerCase(),
            Pool: userPool
        };

        let cognitoUser = new CognitoUser(userData);

        cognitoUser.confirmRegistration(this.state.verification_code, true,
            (err, result) => {
                alert(result);
                this.setState({verify: false, register: false})
        });
    }

    render() {

        if(this.state.isLogin){
            return <TopMenu user={
                {
                    cognitoUser: this.state.cognitoUser,
                    cognitoId: this.state.idToken,
                    accessToken: this.state.accessToken,
                }
            } />
        }

        return (
                <div className="wrapper">
                    <header className="container">
                        <div className="logo_text">
                            <img src={require("./resources/AR-Arboreal-logo-turkos.png")} alt="Arboreal"/>
                            <p>FOREST</p>
                        </div>

                        {this.state.verify ? this.getVerify() : this.state.register ? this.getRegister() : this.getLogin()}

                    </header>
                </div>
        );
    }

    getLogin(){
        return (
            <div className="theme">
                <span>Login</span>
                <div className="form_group" style={{marginTop: 15}}>
                    <label>Email :  &nbsp; &nbsp; &nbsp;  </label>
                    <input type="text" name="userEmail"
                           placeholder={"email"}
                           onChange={(event) => this.setState({username: event.target.value})}
                           value={this.state.username.toLowerCase()}
                    />
                </div>
                <div className="form_group">
                    <label>Password :</label>
                    <input type="password" name="userPassword"
                           placeholder={"password"}
                           onChange={(event) => this.setState({password: event.target.value})}
                           value={this.state.password}
                           onKeyPress={this.keyPressed.bind(this)}
                    />
                </div>
                <div>
                    <input type="button" name="submit" value={"Login"}
                           className="login_button"
                           onKeyPress={this.keyPressed}
                           onClick={() => this.login()}
                           style={{}}/>
                </div>
                <div className="login_register">
                    { /* eslint-disable-next-line */}
                    { /* <a onClick={() => this.setState({register: true, verify: false})}>{"Sign up?"}</a> */}
                    {/* eslint-disable-next-line */}
                    { /* <a onClick={() => this.setState({verify: true, register: false})}>{"Verify code?"}</a>*/}
                    {/*<a style={{ color: "black" }} onClick={() => this.setState({ forgotPassword: true })}>{"Forgot password?"}</a>*/}
                </div>

            </div>
        )
    }

    keyPressed(event) {
        if (event.key === "Enter") {
            this.login()
        }
    }

    getRegister() {
        return (
            <div className="theme">
                <span>Register</span>
                <div className="form_group" style={{marginTop: 15}}>
                    <label>Given Name</label>
                    <input type="text"
                           placeholder={"Given Name"}
                           onChange={(event) => this.setState({given: event.target.value})}
                           value={this.state.given}
                    />
                </div>
                <div className="form_group" style={{marginTop: 15}}>
                    <label>Family Name</label>
                    <input type="text"
                           placeholder={"Family Name"}
                           onChange={(event) => this.setState({family: event.target.value})}
                           value={this.state.family}
                    />
                </div>
                <div className="form_group" style={{marginTop: 15}}>
                    <label>Email</label>
                    <input type="text"
                           placeholder={"email"}
                           onChange={(event) => this.setState({email: event.target.value})}
                           value={this.state.email.toLowerCase()}
                    />
                </div>
                <div className="form_group">
                    <label>Password :</label>
                    <input type="password"
                           placeholder={"password"}
                           onChange={(event) => this.setState({create_password: event.target.value})}
                           value={this.state.create_password}
                    />
                </div>
                <div className="form_group">
                    <label>Repeat:</label>
                    <input type="password"
                           placeholder={"repeat password"}
                           onChange={(event) => this.setState({repeat_password: event.target.value})}
                           value={this.state.repeat_password}
                    />
                </div>
                <div>
                    <input type="button" name="submit" value={"Register"}
                           className="login_button"
                           onClick={() => this.register()}
                           style={{}}/>
                </div>
                <div className="login_register">
                    { /* eslint-disable-next-line */}
                    <a onClick={() => this.setState({register: false})}>{"Back to login"}</a>
                </div>
            </div>
        )
    }

    getVerify() {
        return (
            <div className="theme">
                <span>Verify</span>
                <div className="form_group" style={{marginTop: 15}}>
                    <label>Email</label>
                    <input type="text"
                           placeholder={"email"}
                           onChange={(event) => this.setState({email: event.target.value})}
                           value={this.state.email}
                    />
                </div>
                <div className="form_group">
                    <label>Code:</label>
                    <input type="password"
                           placeholder={"Check your email for verification code"}
                           onChange={(event) => this.setState({verification_code: event.target.value})}
                           value={this.state.verification_code}
                    />
                </div>
                <div>
                    <input type="button" name="submit" value={"Register"}
                           className="login_button"
                           onClick={() => this.verifyEmail()}
                           style={{}}/>
                </div>
                <div className="login_register">
                    { /* eslint-disable-next-line */}
                    <a onClick={() => this.setState({verify: false})}>{"Back to login"}</a>
                </div>
            </div>
        )
    }
}
export default withCookies(Login);